import React from 'react'
import {
  Box,
  Flex,
  Text,
  IconButton
} from '@chakra-ui/react'
import { EditIcon, DeleteIcon } from '@chakra-ui/icons'
import { TaskCardProps } from './types'

const TaskCard: React.FC<TaskCardProps> = ({
  task,
  onEdit,
  onDelete,
  cardBg,
  cardBorder
}) => (
  <Box
    p={3}
    bg={cardBg}
    borderRadius="md"
    boxShadow="sm"
      borderWidth="1px"
      borderColor={cardBorder}
      width="100%"
      mb={2}
    >
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Text fontWeight="bold" mb={2} noOfLines={2}>
          {task.text}
        </Text>
        <Flex>
          <IconButton
            aria-label="Edit task"
            icon={<EditIcon />}
            size="sm"
            variant="ghost"
            mr={1}
            onClick={() => onEdit(task)}
          />
          <IconButton
            aria-label="Delete task"
            icon={<DeleteIcon />}
            size="sm"
            variant="ghost"
            colorScheme="red"
            onClick={() => onDelete(task.id)}
          />
        </Flex>
      </Flex>
      {task.description && (
        <Text fontSize="sm" color="gray.500" noOfLines={3}>
          {task.description}
        </Text>
      )}
    </Box>
  )

export default TaskCard